import React from "react";
import cx from "classnames";

const InputField = ({
  children,
  className,
  hint,
  id,
  label,
  meta,
  name,
  required,
}) => (
  <div className={cx("gkit-field", className)}>
    {label && (
      <label className="gkit-input-label" htmlFor={id || name}>
        {label}
        {/*
          Hidden from assistive tech — the control carries `aria-required`, so
          announcing the asterisk too would read as "Email star".
        */}
        {required && (
          <span aria-hidden="true" className="gkit-required">
            *
          </span>
        )}
        {hint && <span className="gkit-input-hint">{hint}</span>}
      </label>
    )}
    {children}
    {meta && meta.touched && meta.error && (
      // The mock shows a red border only — the message stays for a11y.
      <div className="gkit-invalid-feedback">{meta.error}</div>
    )}
  </div>
);

export default InputField;
